
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astrology",
      function () {
        return require("private-next-pages/astrology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astrology"])
      });
    }
  